<script setup lang="ts">
import { computed } from 'vue';

// import SlateSpritesheet from './spritesheet.svg';
import type { IconName } from './types';

interface Props {
  icon: IconName;
  spin?: boolean;
}

const $props = withDefaults(defineProps<Props>(), {
  'spin': false,
});

const url = computed((): string => {
  // return `${SlateSpritesheet}#${$props.icon}`;
  return `/img/spritesheet.svg#${$props.icon}`;
});
</script>

<template>
  <span
    class="slate-icon"
    :class="{ 'icon-spin-animator': $props.spin }"
    v-bind="$attrs">
    <slot>
      <svg>
        <use
          :href="url"
          :xlink:href="url"></use>
      </svg>
    </slot>
  </span>
</template>

<style>
.slate-icon {
  display: inline-flex;
  aspect-ratio: 1;
  width: 1em;
  height: 1em;

  text-align: center;
  line-height: 1;

  align-items: center;
  justify-items: center;

  & > svg {
    height: 1em;
    width: 1em;
  }
}

.slate-icon > svg {
  fill: currentColor;
  max-width: 100%;
  max-height: 100%;

  display: block;
  margin: 0 auto;
}

.icon-spin-animator {
  -webkit-animation-name: fa-spin;
  animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
  animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
  animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
  animation-timing-function: var(--fa-animation-timing, steps(8));
}
</style>
